import React from "react";
import styles from "./Text.module.scss";

export default function Text({ size, children, fw }) {
  let classes;

  if (size === "large") {
    classes = styles.large;
  } else if (size === "normal") {
    classes = styles.normal;
  } else if (size === "base") {
    classes = styles.base;
  } else if (size === "small") {
    classes = styles.small;
  } else if (size === "small_s") {
    classes = styles.small_s;
  }

  if (fw === 500) {
    classes += ` ${styles.fw500}`;
  } else if (fw === 600) {
    classes += ` ${styles.fw600}`;
  } else if (fw === 700) {
    classes += ` ${styles.fw700}`;
  }

  return <p className={classes}>{children}</p>;
}
